var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobile())?_c('div',[_c('TaskDetailMobile',{attrs:{"lfdnr":_vm.lfdnr}})],1):_c('div',[_c('TaskDetail',{attrs:{"lfdnr":_vm.lfdnr}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }